export default __webpack_public_path__ + "static/media/calendar-icon.50d8c1aa.svg";